import TemplateLayout from "../../../../../providers/TemplateLayout";
import React from "react";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../hooks/app";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ROLES } from "../../../../../constants";

function PreSoloTwo({ templateName }: { templateName: string }) {

  const user = useAppSelector(getUser)
  const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
  const [flight, setFlight] = React.useState("")
  const dispatch = useDispatch()
  React.useEffect(() => {
    const templateText = `I certified that ${name} has received and logged pre-solo flight training for the maneuvers and procedures that are appropriate to the ${flight} aircraft. I have determined [he or she] has demonstrated satisfactory proficiency and safety on the maneuvers and procedures required by §61.87 in this or similar make and model of aircraft to be flown.`
    dispatch(setTemplateText(templateText))
  }, [name, flight, dispatch])

  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR: 1552.23(c)/(d)</label>
      </div>
      <div className="col-12 my-2">
        <p className="certificate_text">
          I certified that <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has received and logged pre-solo flight training for the maneuvers and procedures that are appropriate to the
          <input type="text" onChange={(e) => setFlight(e.target.value)} placeholder="aircraft" /> aircraft. I have determined [he or she] has demonstrated satisfactory proficiency and safety on the maneuvers and procedures required by §61.87 in this or similar make and model of aircraft to be flown.
        </p>
      </div>
    </TemplateLayout>
  );
}

export default PreSoloTwo;
